import { axiosInstance } from '../axios/axiosConfig';

const baseUrl = '/TrainerAvailabilities';

export const getTrainerAvailabilitiesByTrainerPublicId = async (trainerPublicId) => {
    var result = await axiosInstance.get(`${baseUrl}/trainerPublicId=${trainerPublicId}`);
    return result.data;
};
